import { PageLoadError } from '@components/page-load-error';
import { getExternalAccountsQueryOptions } from '@features/accounts/api/external-accounts/get-external-accounts';
import { createFileRoute } from '@tanstack/react-router';
import React from 'react';
import ExternalAccountsLayout from './-layouts/external-accounts-layout';

export const Route = createFileRoute('/_authenticated/dashboard/external')({
  component: ExternalAccountsLayout,
  errorComponent: ({ error }) => (
    <PageLoadError pageName='External' error={error} />
  ),
  loader: async ({ context }) => {
    await context.queryClient.ensureQueryData(getExternalAccountsQueryOptions);
    return null;
  },
  onEnter: () => window.scrollTo(0, 0),
});
